import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import Content from './Content';
import metaOverrideSet from './MetaOverrideSet';

const ScenarioSelectionViewInsightsStepTemplate = ({
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
      LayoutProps={{
        onlyRenderLayout: true,
      }}
      disableNextButton
    />
  );
};

ScenarioSelectionViewInsightsStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionViewInsightsStepTemplate;
